const userDashboardDictPT = {
  dashboard: "Painel de Controle",
  userDashboard: "Painel de Controle do Usuário",
  wallet: "Carteira",
  transfer: "Transferir",
  transferRequests: "Solicitações de Transferência",
  productServices: "Produtos e serviços",
  maxBalanceReached: "Você atingiu seu saldo máximo.",
  new: "Novo",
  dropshipping: "Dropshipping",
  list: "Lista",
  sales: "Vendas",
  purchases: "Compras",
  network: "Círculo Econômico",
  directs: "Diretos",
  all: "Todos",
  coupons: "Cupons",
  attributes: "Atributos",
  withdraw: "Saque",
  yourStore: "Sua Loja",
  favorites: "Favoritos",
  isService: "Esta subcategoria é um serviço?",
  importProducts: "Importar Produtos",
  pageNotFound: "Página não encontrada",
  popupHeader1: "Faltam",
  popupHeader2: "dia(s) para expirar sua assinatura",
  subscriptionExpirationDate: "Data de expiração da assinatura",
  wantToRenewSubscription: "Você quer renovar sua assinatura?",
  subscription: "Assinatura",
  renewSubscription: "Renovar Assinatura",
  payWithPaypal: "Pagar com Paypal",
  walletBalancerRenew: "Saldo na carteira",
  paymentMethods: "Formas de pagamento",
  errorRenewingSubscription:
    "Houve um erro ao efetuar a renovação da sua assinatura, tente novamente",
  youWantRenewWalletBalance: "Você deseja renovar com o saldo na carteira?",
  subscriptionRenewed: "Assinatura renovada com sucesso!",
  yourSubcriptionExpired: "Sua assinatura expirou",
  wantToRenewyourSubscription: "Você deseja renová-la?",
  unfavorite: "Desfavoritar",
  waitLabel:
    "Espere sua etiqueta ser gerada. Apenas aperte no botão abaixo quando o seu pedido for pego pela transportadora.",
  freeRenewalsRemaining: "Renovações gratuitas restantes",
  BOZZA: "Aguardando aprovação",
  INSPEDIZIONE: "Em trânsito",
  RITIRORICHIESTO: "Retirada solicitada",
  CONSEGNATA: "Entregue",
  errorDownloadLabel: "Houve um erro ao criar a etiqueta",
  nextAction: "Próximo",
  closeAction: "Fechar",
  backAction: "Voltar",
  welcomeToExtraconomy: "Bem-vindo à Extraconomy",
  dashboardWelcomeMessage: "Seja bem-vindo à ",
  ifYouWantToSellOnExtraconomy:
    "Se você deseja vender no extraconomy, então siga os passos para aprender como criar sua loja e seus produtos",
  registerYourAddress: "Registre seu endereço",
  initiallyYouNeedToRegisterYourAddress:
    "Inicialmente você precisa cadastrar seu endereço para que possamos utilizá-lo para as entregas",
  fillInYourContactPhoneNumber: "Preencha seu número de telefone de contato",
  fillInYourContactNumber:
    "Preencha seu telefone de contato para que possamos entrar em contato com você caso necessário",
  fillInTheDetailsAboutTheShippingService: "Preencha os dados sobre o serviço de frete",
  saveTheModifiedInformation: "Salve as informações modificadas",
  afterFillingInAllTheInformation:
    "Depois de preencher todas as informações, clique em salvar para que as informações sejam salvas",
  onThisPageYouWillConfigure:
    "Nessa página você configurará sua loja para poder vender seus produtos",
  finallyOnThisPageYouWillRegisterYourProducts:
    "Por fim nessa página você irá cadastrar seus produtos",
  publicKey: "chave pública",
  privateKey: "chave privada",
  accessWallet: "Acessar carteira",
  disconnectWallet: "Desconectar Carteira",
  notifications: "Notificações",
  noNotifications: "Não há notificações",
  StoresMap: "Mapa de Lojas",
  map: "Mapa",
  physicalStore: "Loja Física",
  payments: "Pagamentos",
  payWithQrCode: "Pagar com QR Code",
  payWithQrCodeDescription: "Aponte sua câmera para o QR Code de pagamento.",
  createChargeWithQrCode: "Criação de cobrança",
  createChargeWithQrCodeDescription: "Crie uma cobrança por QR Code",
  paymentTransaction: "Você deseja realizar o pagamento dessa transação?",
  pay: "Pagar",
  transactionValue2: "Valor da transação",
  banners: "Banners",
  amountToBeReceived: "Valor a receber",
  discountPercentual: "Desconto percentual",
  discountAbsolut: "Desconto absoluto",
  none: "Nenhum",
  percentual: "Percentual",
  minimalOrderValueToActivateSetting: "Valor mínimo do pedido para ativar a configuração",
  successSaveFreightRule: "Regra de frete salva com sucesso",
  feightRules: "Regras do frete",
  setShippingRulesForYourStore: "Defina as regras de frete para sua loja.",
  newFringeBenefit: "Novo Voucher",
  newProduct: "Novo Produto",
  listProducts: "Listar Produtos",
  listFringeBenefits: "Listar Vouchers",
  video: "Vídeo",
  dragVideoFile: "Arraste o arquivo de vídeo aqui",
  videoUploadedSuccessfully: "Vídeo enviado com sucesso",
  videoNotSupported: "Seu navegador não suporta reprodução de vídeo",
  uploadVideoMaxSize20MB: "Faça upload de um vídeo de até 20MB para sua loja",
  videoSizeExceeds20MB: "O tamanho do vídeo excede 20MB",
  balanceAvailableForWithdrawal: "Saldo disponível para saque:",
  centralFinanceira: "Central Financeira",
  financialHubSubtitle: "Acompanhe e gerencie as operações da sua carteira Extraconomy.",
  patrimonyConsolidated: "Patrimônio consolidado",
  last30Days: "nos últimos 30 dias",
  walletEuro: "CARTEIRA",
  withdrawable: "SACÁVEL",
  availableForWithdrawal: "Disponível para saque",
  withdrawAction: "Sacar",
  statement: "Extrato",
  useInStore: "Usar na loja",
  extracredit: "Extracredit",
  consumption: "CONSUMO",
  purchasingPower: "poder de compra",
  quickOperations: "Operações Rápidas",
  transferECR: "Transferir ECR",
  financial: "Financeiro",
  overview: "Visão Geral",
  transactions: "Transações",
  lifetimeWalletId: "ID",
  lifetimeWalletEntry: "Entrada",
  lifetimeWalletOutcome: "Saída",
  bankAccounts: "Contas bancárias",
  balanceSummary: "Resumo do saldo",
  totalAvailable: "Total disponível",
  credit: "Crédito",
  debit: "Débito",
  originOfFunds: "Origem dos recursos financeiros",
  transactionsCarriedOut: "Transações realizadas",
  withdrawals: "Retiradas",
  requestWithdrawal: "Solicitar saque",
  dailyIncome: "Renda diária",
  noBankAccountWarning:
    "Nenhuma conta bancária cadastrada. Para solicitar saques, cadastre uma conta.",
  bankAccountSettingsLink: "Configurações de contas bancárias",
  requestWithdrawalButton: "Solicitar saque",
  history: "Histórico",
  availableBalance: "Saldo disponível",
  howToUseCredits: "Como usar seus créditos",
  creditMovement: "Movimentação de créditos",
  comingSoon: "Em breve",
  invest: "Investir",
  swap: "Swap",
  bankAccountFormTitle: "Cadastro de conta bancária",
  bankAccountFormTitleEdit: "Editar conta bancária",
  bankAccountFormSubtitle: "Insira os dados da sua conta.",
  identification: "Identificação",
  mainAccount: "Conta principal",
  mainAccountHelp: "Marque para definir como conta principal.",
  bankDetails: "Dados bancários",
  accountType: "Tipo de conta",
  email: "E-mail",
  bankAccountRegister: "Cadastrar",
  registeringAccount: "Cadastrando sua conta. Aguarde.",
  invalidIban: "IBAN inválido. Verifique o número informado.",
  accountRegisteredSuccess: "Conta cadastrada com sucesso.",
  accountUpdatedSuccess: "Conta atualizada com sucesso.",
  accountDeletedSuccess: "Conta excluída com sucesso.",
  addAccount: "Cadastrar conta",
  configure: "Configurar",
  myAccounts: "Minhas contas",
  noAccountsMessage:
    "Você ainda não tem contas bancárias cadastradas. Cadastre uma nova conta para realizar transferências.",
  transferTo: "Transferir para",
  selectAccount: "Selecione uma conta",
  processingWithdrawal: "Processando saque...",
  cancel: "Cancelar",
  save: "Salvar",
  principal: "Principal",
  delete: "Excluir",
  confirmDeleteAccount: "Tem certeza que deseja excluir esta conta?",
  attention: "Atenção",
  yes: "Sim",
  no: "Não",
  confirmWithdrawal: "Confirmar saque",
  searchByTransaction: "Pesquise por transação",
  filter: "Filtrar",
  transaction: "Transação",
  operationType: "Tipo de operação",
  registrationDate: "Data de inscrição",
  noOperationsRecords: "Ainda não há registros de operações.",
  saleInStore: "Venda de produto na loja",
  purchaseInStore: "Compra de produto na loja",
  register: "Cadastrar",
  paymentMethodExtracredit: "Extracredit",
  paymentMethodWallet: "Saldo da carteira",
  paymentMethodPayPal: "PayPal",
  paymentMethodBankTransfer: "Transferência bancária",
  paymentMethodMultiple: "Múltiplos",
  pendingReceipts: "Recebimentos pendentes",
  pendingReceiptsSent: "enviou",
  pendingReceiptsHint: "Estes valores só entrarão no saldo após o aceite.",
  approve: "Aprovar",
  recipientSelection: "Seleção do destinatário",
  recipientSelectionHint: "Selecione quem receberá sua transferência.",
  chooseRecipient: "Escolha o destinatário",
  searchRecipient: "Pesquisar destinatário...",
  userNotFound: "Este usuário não foi encontrado. Verifique os dados digitados e tente novamente.",
  recipientDetails: "Detalhes do destinatário",
  changeRecipient: "Alterar destinatário",
  values: "Valores",
  valuesHint: "Insira quanto você deseja transferir para {name}.",
  available: "Disponível",
  enterAmount: "Digite o valor",
  platformFee: "Taxa da plataforma",
  transferSummary: "Resumo da transferência",
  transferSummaryHint: "Revise e confirme antes de finalizar sua transferência.",
  sendTo: "Envie para",
  recipient: "Destinatário",
  transferCompleted: "Transferência realizada",
  goToStatement: "Ir para extrato",
  powerOfUse: "Poder de uso",
  powerOfUseDescription: "Pague até {percent}% de suas compras usando seu saldo de Extracréditos.",
  powerOfUseLabel: "Você pode usar até {percent}% do seu saldo ECR",
  powerOfUseManagerRule: "A cada indicação paga (não via voucher) você libera 2%.",
  powerOfUseOtherRule: "A cada indicação paga você libera 1%.",
  unlocked: "liberado",
  goal: "Meta",
  unlockMore: "Desbloqueie +",
  powerOfUseManagerUnlock:
    "Convide novos Partners (pagos, não via voucher) para aumentar seu limite.",
  powerOfUseOtherUnlock: "Convide novos Partners pagos para aumentar seu limite.",
  opportunitiesToUse: "Oportunidades com Extracréditos",
  accessStore: "Acessar loja",
  completeStatement: "Extrato completo",
  useCreditPercent: "Use {percent}% Crédito",
  credits: "Créditos",
  totalValue: "Valor total",
  transferExtracredit: "Transferir Extracredit",
  transferExtracreditSubtitle:
    "Transfira Extracréditos para outros usuários no ecossistema Extraconomy.",
  transferConfirmDisclaimerBefore: "Ao clicar em ",
  sendCredits: "Enviar créditos",
  transferConfirmDisclaimerMiddle: ", concedo permissão à ",
  companyExtraconomy: "Extraconomy",
  transferConfirmDisclaimerAfter: " para prosseguir com a transação detalhada.",
  securityValidationTitle: "Validação de segurança",
  securityValidationEmailSent:
    "Para sua segurança, enviamos um código de {length} caracteres para {email}",
  securityValidationConfirmTransfer:
    "Digite o código para confirmar a transferência de {amount} para {recipient}",
  securityValidationConfirmWithdrawal:
    "Digite o código para confirmar o saque de {amount} para {recipient}",
  securityValidationCodeExpires: "o código expira em {time}",
  securityValidationResend: "Reenviar código",
  securityValidationResendIn: "Reenviar código (em 5min)",
  securityValidationValidate: "Validar código",
  rejectNotAvailable: "Recusar não está disponível.",
  search: "Procurar",
  toAgreeAndReceiveInsertCode: "Para concordar e receber, insira o código enviado ao seu e-mail:",
  confirmYourAction: "Confirme sua ação",
  seeDetails: "Ver detalhes",
  whiteLabel: "White Label",
  whiteLabelSettingsTitle: "Configurações de aparência",
  whiteLabelSettingsSubtitle: "Personalize as configurações de aparência da sua dashboard.",
  whiteLabelSaveChanges: "Salvar alterações",
  whiteLabelAssets: "Recursos visuais",
  whiteLabelLogo: "Logo",
  whiteLabelFavicon: "Favicon",
  whiteLabelChooseFile: "Escolher arquivo",
  whiteLabelClickToUpload: "Clique para carregar",
  whiteLabelOrDragDrop: "ou arraste e solte",
  whiteLabelFileFormatsLogo: "SVG, PNG, JPG ou GIF (máx. 400×400px)",
  whiteLabelFileFormatsFavicon: "SVG, PNG, JPG ou GIF (máx. 64×64px)",
  whiteLabelBrandColors: "Cores da marca",
  whiteLabelPrimaryColor: "Cor principal",
  whiteLabelSecondaryColor: "Cor de suporte",
  whiteLabelBackgroundColor: "Fundo da plataforma",
  whiteLabelTextColor: "Cor dos textos",
  whiteLabelTypography: "Tipografia",
  whiteLabelFont: "Fonte",
  whiteLabelSelectFont: "Selecione a fonte",
  whiteLabelImageUploaded: "Imagem enviada com sucesso",
  whiteLabelThemeCreated: "Tema criado com sucesso",
  whiteLabelThemeUpdated: "Tema atualizado com sucesso",
  whiteLabelChangesReset: "Alterações restauradas aos padrões",
  whiteLabelDefaultSettings: "Configurações padrão",
  whiteLabelCustomNetworkDefault: "Rede personalizada",
  whiteLabelPrimaryColorHelp:
    "Representa a identidade da sua marca. Será usado em botões de ação, links ativos e elementos de maior importância.",
  whiteLabelSecondaryColorHelp:
    "Uma cor de suporte para criar contraste. Aparecerá em badges, ícones de fundo e detalhes visuais secundários.",
  whiteLabelBackgroundColorHelp:
    "A cor predominante atrás dos conteúdos. Recomendamos tons claros (como branco ou cinza claro) para facilitar a leitura.",
  whiteLabelTextColorHelp:
    "Define a cor de títulos e parágrafos. Escolha um tom escuro que contraste bem com o fundo da plataforma.",
  whiteLabelFontHelp:
    "A família tipográfica que dará voz à sua plataforma. Escolha uma fonte legível e alinhada com sua imagem empresarial.",
  whiteLabelLogoPreview: "Prévia do logo",
  whiteLabelFaviconPreview: "Prévia do favicon",
  myCards: "Meus Cartões",
  myCardsSubtitle: "Visualize e gerencie seus cartões virtuais.",
  myCardsEmpty: "Nenhum cartão disponível.",
  myCardsClickToFlip: "Clique no cartão para virar",
  myCardActive: "Ativo",
  myCardInactive: "Inativo",
  orderSingular: "pedido",
  orderPlural: "pedidos",
  awaitingProcessing: "Aguardando processamento",
  noPending: "Nenhuma pendente",
  managerDashboardErrorLoad: "Erro ao carregar dados do dashboard",
  managerStoreStatusPending: "Pendente",
  managerNetworkLevelSenior: "Sênior",
  managerWalletChangeVsPrevious: "+2% vs mês período anterior",
  managerBalanceSales: "de vendas",
  managerTrackStoreHere: "Acompanhe sua loja aqui.",
  managerBilling: "FATURAMENTO",
  managerInProcessing: "em processamento",
  managerLiveStore: "LOJA AO VIVO",
  managerNetworkEarnings: "GANHOS DE REDE",
  managerNetworkLevelLabel: "Nível de rede",
  managerTotalEarnings: "Ganhos totais",
  managerB2bPurchasingPower: "Poder de compra B2B",
  managerBonusAds: "Bonus ADS",
  managerAdsForExternalAds: "ads para anúncio externos",
  managerFooterCompanyName: "EXTRACONOMY GLOBAL srl",
  managerFooterAddress: "Via Nomentana, 1018 - 00137 Roma (IT)",
  managerFooterTaxInfo: "P. Iva e C.F. 16948681008",
  managerFooterRea: "REA 1686351",
  economicCircle: "Círculo Econômico",
  economicCircleSubtitle: "Acompanhe seu círculo econômico e expansão.",
  invite: "Convite",
  inviteSubtitle: "Convide membros e expanda sua rede de influência.",
  currentStatus: "Status atual",
  members: "Membros",
  networkPower: "Poder de rede",
  activeInfluence: "Influência ativa",
  networkEarnings: "Ganhos de rede",
  thisMonth: "este mês",
  totalAccumulatedLifetime: "Total acumulado (Lifetime)",
  directCommission: "Comissão direta",
  networkCommission: "Comissão de rede",
  networkHighlightsTop5: "Destaques da rede (Top 5)",
  recentMembers: "Membros recentes",
  viewAll: "Ver todos",
  transactionHistory: "Histórico de transações",
  noRecentMembers: "Nenhum membro recente.",
  origin: "Origem",
  type: "Tipo",
  date: "Data",
  value: "Valor",
  paid: "Pago",
  goalForGold: "Meta para GOLD",
  copied: "Copiado",
  copiedToClipboard: "Copiado para a área de transferência",
  qrcodereferralLinks: "QR Code dos links de indicação",
  referralLinksExplanation: "Faça login para gerar links de indicação.",
  share: "Compartilhar",
  directMembers: "Membros diretos",
  indirectMembers: "Membros indiretos",
  totalReceived: "Total recebido",
  withdrawalsMade: "Saques realizados",
  membersAndTransactions: "Membros e transações",
  membersAndTransactionsSubtitle: "Membros e transações do seu círculo.",
  searchByMember: "Pesquise por membro",
  indirects: "Indiretos",
  noMembers: "Nenhum membro.",
  name: "Nome",
  actions: "Ações",
  completed: "Concluído",
  pending: "Pendente",
  canceled: "Cancelado",
  active: "Ativo",
  inactive: "Inativo",
  activeDigitalAssets: "Ativos digitais",
  privacyPolicy: "Política de privacidade",
  managerMobileNavOpenMenu: "Abrir menu",
  partnerB2bTitle: "Partner B2B",
  partnerB2bSubtitle: "Encontre e conecte-se com parceiros estratégicos na sua região.",
  partnerB2bSearchPlaceholder: "Códigos ATECO ou áreas de atividade...",
  partnerB2bRadiusLabel: "Raio",
  partnerB2bRadiusKm: "km",
  partnerB2bSearch: "Pesquisar",
  partnerB2bAddressWarningText:
    "É necessário configurar a sua posição (código postal e endereço) para usar a busca geolocalizada.",
  partnerB2bConfigurePosition: "Configurar posição",
  partnerB2bEmptyState:
    "Não foram encontrados resultados com os critérios atuais. Tente ampliar o raio de pesquisa ou remover alguns filtros.",
  partnerB2bSubnetOnly: "Esta página está disponível apenas para membros de uma subnet.",
  partnerB2bContact: "Contacto",
  partnerB2bActivities: "Atividades / ATECO",
  partnerB2bContactPartner: "Contactar o parceiro",
  partnerB2bGetDirections: "Obter indicações",
  partnerB2bDistanceFromYou: "A {km} km de si",
  partnerB2bClosestPartners: "Parceiros mais próximos",
  partnerB2bShowingResultsInRadius: "Mostrando {count} {countLabel} em um raio de {radius} km",
  partnerB2bResult: "resultado",
  partnerB2bResults: "resultados",
  partnerB2bWaitingForSearch: "Aguardando uma busca para listar parceiros.",
  partnerB2bNoPartnersFound: "Nenhum parceiro encontrado para os filtros atuais.",
  partnerB2bFromYou: "de você",
  partnerServicesTitle: "Serviços para parceiros",
  partnerServicesTabBusiness: "Serviços para empresas",
  partnerServicesTabIndividuals: "Serviços para particulares",
  partnerServicesActivateService: "Ativar serviço",
  partnerServicesAwaitingFeedback: "Aguardando retorno",
  partnerServicesServiceActivated: "Serviço ativado com sucesso",
  partnerServicesServiceActivationFailed: "Falha ao ativar o serviço",
  partnerServicesMenuLabel: "Serviços para parceiros",
  backToFedernet: "Voltar para a Associação",
  performanceChartLabel: "Desempenho Comercial",
  performanceChartTitle: "Desempenho comercial",
  performanceChartErrorLoadingData: "Erro ao carregar dados",
  performanceChartLoading: "Carregando...",
  accessCommercialDashboard: "Acessar painel comercial",
  recentOperations: "Últimas operações",
  recentOperationsJustNow: "Agora",
  recentOperationsMoreItems: "(+{count})",
  recentOperationsCustomerEmptyState: "Você ainda não realizou operações de compra.",
  recentOperationsExploreStore: "Conhecer a loja Extraconomy",
  customerHomeExtracreditBalanceTitle: "Saldo Extracredit (ECR)",
  customerHomeExtracreditEquivalent: "Equivalente a ~ {value} no circuito",
  customerHomePendingTransactionsTitle: "Transações pendentes",
  customerHomePendingTransactionsSubtitle: "Visualize seus pedidos",
  customerHomeQuickActionsTitle: "Funções rápidas",
  customerHomeExploreStores: "Explorar lojas",
  customerHomeFutureTitle: "Em breve: novas funcionalidades para Customers.",
  customerHomeFutureSubtitle:
    "Estamos preparando recursos para ampliar as possibilidades de compra e serviços no seu painel.",
  customerHomeFutureImageAlt: "Seção informativa do customer",
  myPurchases: "Minhas compras",
  myPurchasesSubtitle: "Acompanhe suas compras e o status de cada pedido.",
  totalPurchases: "Total de compras",
  lastPurchaseDate: "Última compra",
  noPurchases: "Nenhuma compra ainda",
  searchByIdOrSeller: "Buscar por ID ou vendedor",
  partnerStoresMenuLabel: "Lojas conveniadas",
  upgradePageNotAvailableTitle: "Upgrade não disponível",
  upgradePageNotAvailableDescription:
    "Este perfil não possui opções de upgrade disponíveis no momento.",
  upgradePageHeadlineCustomer: "Desbloqueie seu potencial de ganho",
  upgradePageHeadlinePartner: "Escale seu negócio no e-commerce",
  upgradePageHeadlineSeller: "Domine seu território com geolocalização",
  upgradePageHeadlineStore: "Inicie seu crescimento no e-commerce",
  upgradePageSubheadlineCustomer:
    "Torne-se Partner ou Manager para acessar o plano de carreira e gerar ganhos concretos no nosso ecossistema.",
  upgradePageSubheadlinePartner:
    "Ative o plano StartSeller e leve sua loja física para o online, superando qualquer limite geográfico.",
  upgradePageSubheadlineSeller:
    "Migre para o perfil Manager para receber automaticamente clientes da sua região pelo nosso aplicativo.",
  upgradePageSubheadlineStore:
    "Ative o plano Start Seller para liberar vendas on-line e publicação de produtos no marketplace.",
  upgradePaymentTitle: "Concluir upgrade",
  upgradeMostPopular: "mais escolhido",
  upgradePlanNamePartner: "PARTNER",
  upgradePlanNameSeller: "SELLER",
  upgradePlanNameManager: "MANAGER",
  upgradePlanNameStartSeller: "START SELLER",
  upgradePlanDescriptionPartner: "Para quem está começando a vender online.",
  upgradePlanDescriptionSeller: "Para quem quer aumentar as próprias vendas.",
  upgradePlanDescriptionManager: "Para quem quer expandir o próprio negócio.",
  upgradePlanDescriptionStartSeller: "Para quem quer aumentar as próprias vendas.",
  upgradeFeatureStorefront: "Vitrine online",
  upgradeFeatureEconomicCircle: "Círculo econômico",
  upgradeFeatureNoMonthlyFee: "Sem pagamentos mensais",
  upgradeFeaturePersonalEcommerce: "E-commerce pessoal",
  upgradeFeatureDropshipping: "Inclui Dropshipping",
  upgradeFeatureOnlineStore: "Loja online",
  upgradeFeatureGeolocationActive: "Geolocalização ativa",
  upgradeFeatureAllIncluded: "Tudo incluso",
  upgradeStartSellerRenewal: "Renovação anual: EUR 35,00",
  storeActivateStartSellerWarning:
    "Para publicar produtos, ative o plano Start Seller no upgrade da conta.",
  storeActivateStartSellerCta: "Ativar Vendas On-line Start Seller",
  productLimitReached:
    "Você atingiu o limite máximo de {limit} anúncios. Para cadastrar novos anúncios, faça upgrade no seu plano.",
  storeProductsLimitWarning:
    "Você atingiu o limite de {limit} anúncios do seu plano. Faça upgrade para continuar cadastrando produtos e serviços.",
  paymentsPysicalStore: "Pagamentos da loja física",
  payPhysicalStore: "Pagar loja física",
  physicalStoreProofSubmitted: "Comprovante enviado, aguardando validação.",
  securityCodeLabel: "Código de segurança (enviado para o seu e-mail):",
  securityCodeSend: "Enviar código",
  securityCodeResend: "Reenviar código",
  securityCodeHint: "Clique em \"Enviar código\" e digite o código que chegar no seu e-mail. Cada novo envio invalida o código anterior.",
  securityCodeSent: "Código enviado! Confira seu e-mail.",
  securityCodeCantBeEmpty: "Informe o código de segurança enviado por e-mail.",
  securityCodeIsWrong: "Código de segurança inválido ou expirado.",
};

export default userDashboardDictPT;
